import { LightShowOperation } from '../Operations/lightshow-operation';
import { Segment } from '../../mp3-slider/mp3-player.component';
import { LightshowSegmentTypes } from './lightshow-segment-types';

/**
 * Lightshow segments do not correspond 1:1 with operations. For example, a color segment
 * will generate 1 set-color operation on every torch/strobe start.
 */
export abstract class LightShowSegment extends Segment {
  public segmentId: string;
  public colors?: string[];
  public imageBackgroundColor?: string;
  public imageUrl?: string;
  public imageName?: string;
  public audioUrl?: string;
  public audioName?: string;
  public segmentType: LightshowSegmentTypes;
  public fadeIn?: number;
  public fadeOut?: number;
  public uniqueid?: string;
  public imageId?: string;
  public minPosition: 50;
  public hidden?: boolean;
  public enableSegmentGrips: boolean;
  public hover?: boolean;
  // will get executed on all segments at the beginning of every cycle
  public init(): void {}
  public abstract addOperations(operations: LightShowOperation[]): void;
}
